var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded bg-gray-400 bg-opacity-35 p-4 pt-3 lg:px-7 lg:pb-7 lg:pt-6"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }